module.exports = __webpack_public_path__ + "img/a-1.e18c547c.jpg";